import React from 'react';
import styled from 'styled-components';

function TimeDivisionLine (props) {
  const { isMain, scheduleData } = props;

  return (
    <TopLevelWrapper>
      {
          scheduleData.isNeedNewDivide ?
          <TextWrapper >
            <TimeText>{scheduleData.viewTime}</TimeText>
            <TextTimeLine isNeedNewDivide={scheduleData.isNeedNewDivide} isMain={isMain}/>
          </TextWrapper>
          :
          <TimeLine/>
      }
    </TopLevelWrapper>
  )
}

export default React.memo(TimeDivisionLine);

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  width: 40px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
`;

const TimeText = styled.p`
  font-family: Poppins-Regular;
  font-size: 12px;

  color: ${props => props.theme.text};
  margin: 0 0 0 0;
`;

const TextTimeLine = styled.div`
  width: 2px;
  height: ${props => props.isMain ? `72px` : `57px`};

  border-right: 1px solid ${props => props.theme.line};
`;

const TimeLine = styled.div`
  width: 2px;
  height: 88px;

  border-right: 1px solid ${props => props.theme.line};
`;
